import React from "react";
import axios from "axios";
import { authService } from "../auth";
import UnauthShare from "../commons/UnauthShare";
import httpService from "../AxiosInterceptors";
import AuthModalComponent from "../LoginExtra/AuthModalComponent";
import { getCDNUrl,
  nFormatter,
  convertUnicode,
  adminFlagData,
  getOptimizedArticleImage,
  redirectToCircle,
  audioTimeFormat,
} from "../commons/CommonFunctions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import * as _ from "lodash";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { DeviceUUID } from 'device-uuid';
import AudioPlayer from 'react-h5-audio-player';
import NotFound from "../404";
import { Link } from "react-router-dom";
import dateUtil from "date-and-time";
import uuid from "react-uuid";
import { pageClickRequest } from "../reducer/blogPageClick/blogPageClick";
import { connect } from "react-redux";
import FeedsUnauthItem from "../Feeds/FeedsUnauthItem";
import ProjectDetailsCommonModal from "../UnauthPageItem/ProjectDetailsCommonModal";

var dateFormat = require("dateformat");

httpService.setupInterceptors();

class UnauthExploreDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSuccess: authService.isAuthenticated(),
      userData: authService.getUserDetailsFromLocalStorage(),
      detailObj: {},
      item: {},
      loginRequired: false,
      notFoundstatusCode: "",
      opportunities: [],
      unAuthPost: [],
      unAuthCircle: [],
      audioS3Url: "",
      audioDuration: "",
      showAudioDurationFlag: false,
      isModalOpen: false,
      projectDetail: {},
    };
    this.initFunction();
  }

  loginRequired = () => {
    this.setState({ loginRequired: true });
    window.$("#loginModal").modal("show");
  }

  handleHook = () => {
    let postBody = {
      userId: localStorage.getItem("deviceId"),
      entityId: this.state.item.id,
      timestamp: new Date().valueOf(),
      entityType: "BLOG",
    };
    if (postBody.userId) {
      this.props.pageClickRequest(postBody);
    }
  };

  componentDidMount() {
    const Deviceuuid = new DeviceUUID().get() + '-' + uuid();
    // let DeviceUuid = '';
    // let ID = "";
    // if (localStorage.getItem('rzp_device_id')) {
    //     DeviceUuid = localStorage.getItem('rzp_device_id');
    //     ID = DeviceUuid.split('.')[1];
    // } else {
    //     DeviceUuid = getDeviceId();
    //     ID = DeviceUuid;
    // }
    if (
      localStorage.getItem("deviceuuID") == null ||
      localStorage.getItem("deviceuuID") == undefined
    ) {
      localStorage.setItem("deviceuuID", Deviceuuid);
    }
    // window
    //   .$(".expldesctophead")
    //   .sticky({ topSpacing: 65, responsiveWidth: true });
    var navPos = window.$(".expldesctophead").offset().top - 64;
    window.$(window).scroll(function () {
      var windscroll = window.$(window).scrollTop();
      if (windscroll >= navPos) {
        window.$(".expldesctophead").addClass("is-sticky");
      } else {
        window.$(".expldesctophead").removeClass("is-sticky");
      }
    });

    window.$(".collapser").click(function () {
      window.$(this).next().collapse("toggle");
    });
    window.$("#commntIco").on("click", function (event) {
      event.preventDefault();
      window.$("#commentbox textarea").focus();
    });
    if (!this.state.loginSuccess) {
      this.getUnauthTrendingOppurtunity(0, 3);
      this.getUnAuthFeedsFetch();
      this.getUnAuthTrendingCircle();
    }
  }

  initFunction() {
    if (this.props.type === "article") {
      this.getArticleDetaiPage();
    } else if (this.props.type === "blog") {
      this.getBlogDetaiPage();
    }
  }

  getTextToSpeech = () => {
        let data = {
            postId: this.state.item?.id
        }
        axios({
            method:'POST',
            url: `${process.env.REACT_APP_userServiceURL}/recommend/ttsdata`,
            data: data,
            withCredentials: true
        }).then((response)=>{
            if(response?.data?.data){
                this.setState({
                    audioS3Url: response?.data?.data
                }, () => {
                  if(this.state.audioS3Url && this.state.audioS3Url.length > 0) {
                      document.getElementsByClassName("rhap_progress-section")[0].classList.add("d-none");
                      const audio = document.querySelector('audio');
                      audio.addEventListener('loadedmetadata', (event) => {
                          this.setState({
                              audioDuration: audioTimeFormat(event.target.duration),
                              showAudioDurationFlag: true
                          })
                      });
                  }
                })
            }
        }).catch((error)=>{
            console.log("Error", error)
        }) 
    }

  getBlogDetaiPage() {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/backend/unauth/explore_blog/getBySlug?slug=" +
        this.props.slug,
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data.body !== null) {
          var dataObj = {
            header: response.data.body.title,
            txt_data: response.data.body.content,
            date: response.data.body.createTime,
            summary_text: response.data.body.hashTags,
            userCustomUrl: response.data.body.userCustomUrl,
            image_url: response.data.body.coverImageUrl,
            name: response.data.body.source,
            likesCount: response.data.body.likesCount,
            commentCount: response.data.body.commentCount,
            userProfileImage: "https://cdn.dscovr.com/images/welogoNew.png",
          };
          document.title = response.data.body.title;
          //this.setState({"detailObj": dataObj,"item": response.data.body});

          this.setState({
            item: response.data.body,
            detailObj: dataObj,
            liked: response.data.body.liked,
            likesCount: response.data.body.likesCount,
          },()=>{
            this.getTextToSpeech()
          });
          this.handleHook();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 404) {
          this.setState({
            notFoundstatusCode: err.response.status,
          });
        }
        this.setState({
          isLoaded: true,
          error: { message: err.response.data.message, err: err.response },
        });
      });
  }

  getArticleDetaiPage() {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_userServiceURL}/unauth/post/getBySlug?slug=${this.props.slug}&admin=${adminFlagData() ? true : false}`,
      withCredentials: true,
    })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.statusCode === 200 &&
          response.data.body !== undefined
        ) {
          let data = response.data.body;
          var dataObj = {
            header: data.title,
            txt_data: data.description,
            date: data.createTime,
            userCustomUrl: !data.userEntityType ? data.userCustomUrl : data.params && data.params.circleSlug,
            summary_text: data.hashTags,
            image_url: this.getCoverImgUrl(data.attachmentIds),
            name: !data.userEntityType ? data.userName : data.params && data.params.circleTitle,
            likesCount: data.likesCount,
            commentCount: data.commentCount,
            userProfileImage: !data.userEntityType ? data.userProfileImage : data.params && data.params.circleImage,
          };

          document.title = data.title;
          this.setState({
            item: data,
            detailObj: dataObj,
            liked: data.liked,
            likesCount: data.likesCount,
          }, () => {
            this.getTextToSpeech();
          });
          this.handleHook();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 404) {
          this.setState({
            notFoundstatusCode: err.response.status,
          });
        }
        this.setState({
          isLoaded: true,
          error: { err: err },
        });
      });
  }

  getCoverImgUrl(arttachmentList) {
    var attachmentUrl =
      "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png";

    if (arttachmentList !== undefined) {
      for (var each of Object.values(arttachmentList)) {
        if (each.attachmentType === "COVER_IMAGE") {
          attachmentUrl = getOptimizedArticleImage(each);
          break;
        }
      }
    }
    return attachmentUrl;
  }

  getFormattedDate(milliseconds) {
    var utcSeconds = milliseconds;
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds / 1000);

    if (isNaN(d) === false) {
      return dateFormat(d, "d-mmm-yyyy");
    }
    return "";
  }

  redirectToProfile = (customUrl) => {
    window.location.href = "/profile/" + customUrl;
  };

  handleLoginClose = () => {
    this.setState({ loginRequired: false });
    window.$("#loginModal").modal("hide");
  };

  getUnauthTrendingOppurtunity = (page, size) => {
    let trendingOpportunityURL =
      process.env.REACT_APP_userServiceURL + "/unauth/trending-opportunity/";
    let url = trendingOpportunityURL + "?page=" + page + "&size=" + size;
    axios({
      method: "get",
      url: url,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.body &&
          response.data.body.content
        ) {
          this.setState({
            opportunities: response.data.body.content,
          });
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  };

  getUnAuthFeedsFetch = () => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/unauth/getNewsFeed/trending?newsFeedType=TOP&page=0&size=3",
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.status === "200 OK") {
          this.setState({
            unAuthPost: response.data.body.content,
          }, () => {
            this.forceUpdate();
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getCost = (project) => {
    let fees = "";
    if (
      (project && project.cost) ||
      project.remuneration ||
      project.renumeration
    ) {
      fees = project.cost || project.remuneration || project.renumeration;
    }
    return fees;
  };
  getUnAuthTrendingCircle = () => {
    let postBody = {
      page: 0,
      size: 4,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_userServiceURL + "/circle/trending-circle",
      data: postBody,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (response && response.data && response.data.status === "200 OK") {
          this.setState({
            unAuthCircle: response.data.body.content,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onPlayAudio = () => {
      document.getElementsByClassName("rhap_progress-section")[0].classList.remove("d-none");
      this.setState({
          showAudioDurationFlag: false
      })
  }

  modalOpen = (slug) => {
    this.setState({ 
      isModalOpen: true
     },() => {
      this.setState({
        slug: "/project/feeds/" + slug,
      });
      this.getUnauthProjectDetails(slug);
    });
  };

  getUnauthProjectDetails = (slug) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_userServiceURL}/unauth/find-project-description-details-by-slug/${slug}`,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        let res = response?.data;
        if (res.status === "200 OK") {
          this.setState({ projectDetail: res?.body }, () => {
            if (this.state.projectDetail && this.state.projectDetail.project) {
              if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.sessionTitle +
                  " | New opportunities and projects to explore | WeNaturalists";
              } else if (this.state.projectDetail.project.title) {
                document.title =
                  this.state.projectDetail.project.title +
                  " | New opportunities and projects to explore | WeNaturalists";
              }
            }
          });
          window.$("#projectDetails").modal("show");
        }
      })
      .catch((err) => {
        if (err && err.response) {
          this.setState({
            notFoundstatusCode: err.response.status,
            error: { message: err.response.data.message, err: err.response },
          });
        }
        this.setState({
          isLoaded: true,
        });
      });
  };

  openModalClose = () => {
    this.setState({
      slug: "",
      isModalOpen: false,
    });
    window.$("#projectDetails").modal("hide");
  };

  handleApply = (slug) => {
    this.setState({
        pathName: slug,
        loginRequired: true,
      },() => {
        window.$("#loginModal").modal("show");
      }
    );
};

  render() {
    return (
      <>
        {this.state.notFoundstatusCode === 404 ? (
          <div className="col-md-12">
            <NotFound />
          </div>
        ) : (
          <div className="col-md-12">
            <div className="projectinn explinner">
              <div className="explpagebannwrap">
                 <a data-fancybox={uuid()}
                      href={this.state.detailObj !== undefined && this.state.detailObj.image_url !== undefined ? getCDNUrl(this.state.detailObj.image_url) : ''}
                  >
                    <LazyLoadImage
                      effect="blur"
                      src={
                        this.state.detailObj !== undefined &&
                          this.state.detailObj.image_url !== undefined
                          ? getCDNUrl(this.state.detailObj.image_url)
                          : "https://cdn.dscovr.com/images/banner-explore-blog-small-new.png"
                      }
                      alt=""
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   this.redirectToProfile(this.state.detailObj.userCustomUrl);
                      // }}
                      // style={{ cursor: "pointer" }}
                    />  
                </a>              
              </div>              
              <div className="expldesctophead">
                <div className="fdtheadleft">                    
                  {this.state.detailObj && this.state.detailObj.news_url && (
                    <h1>
                      <a href={this.state.detailObj.news_url} target="_blank">
                        {this.state.detailObj !== undefined
                          ? this.state.detailObj.header
                          : ""}
                      </a>
                    </h1>
                  )}

                  {this.state.detailObj !== undefined &&
                    this.state.detailObj.news_url === undefined && (
                      <h1>
                        {this.state.detailObj !== undefined
                          ? this.state.detailObj.header
                          : ""}
                      </h1>
                    )}
                  {/* <div className="exptimecount">10 min read</div> */}
                  {this.state.audioS3Url && this.state.audioS3Url.length > 0 &&
                    <div className={this.state.audioDuration && this.state.showAudioDurationFlag ? 'audioSpeakWrap noBar' : 'audioSpeakWrap'}>
                      <AudioPlayer
                          showJumpControls={false}
                          customVolumeControls={[]}
                          customAdditionalControls={[]}
                          showDownloadProgress={false}
                          src={this.state.audioS3Url}
                          onPlay={this.onPlayAudio}
                      />
                      {this.state.audioDuration && this.state.showAudioDurationFlag && <span className='beforePlay'>{this.state.audioDuration}</span>}{}
                    </div>}
                </div>
                <div className="fdtheadright">                   

                  <div className="fdtheadrightbott">
                    <div className="forumrowbright">
                      <div className="likesblk">
                        <a
                          href="javascript:void(0)"
                          className={"like"}
                          onClick={this.loginRequired.bind(this)}
                        />
                        <a
                          href="javascript:void(0)"
                          onClick={this.loginRequired.bind(this)}
                        >
                          {this.state.detailObj.likesCount}&nbsp;
                          <span>
                            {this.state.detailObj.likesCount <= 1
                              ? "Like"
                              : "Likes"}
                          </span>
                        </a>
                      </div>
                      <div className="expCommnt">
                        <a
                          href="javascript:void(0)"
                          className="comments"
                          id="commntIco"
                          onClick={this.loginRequired.bind(this)}
                        >
                          <span>
                            {this.state.detailObj.commentCount}&nbsp;
                            <span>
                              {this.state.detailObj.commentCount <= 1
                                ? "Comment"
                                : "Comments"}
                            </span>
                          </span>
                        </a>
                      </div>
                      <>
                        {this.state.item &&
                          this.state.item.slug && (
                            <UnauthShare
                              shareUrl={this.props.type === "blog" ? "/explore-detail/blog/" : "/explore-detail/article/"}
                              entityId={this.state.item.id}
                              entityType={"EXPLOREBLOG"}
                              shareId={this.state.item.slug}
                              shareOpen={window.location.href.indexOf("share-open") !== -1 ? true : false}
                        />)}       
                        {/* {window.location.href.indexOf("share-open") !== -1
                          ? this.state.item &&
                          this.state.item.slug && (
                            <UnauthShare
                              shareUrl={this.props.type === "blog" ? "/explore-detail/blog/" : "/explore-detail/article/"}
                              entityId={this.state.item.id}
                              entityType={"EXPLOREBLOG"}
                              shareId={this.state.item.slug}
                              shareOpen="true"
                            />
                          )
                          : this.state.item &&
                          this.state.item.slug && (
                            <UnauthShare
                              shareUrl={this.props.type === "blog" ? "/explore-detail/blog/" : "/explore-detail/article/"}
                              entityId={this.state.item.id}
                              entityType={"EXPLOREBLOG"}
                              shareId={this.state.item.slug}
                            />
                          )} */}
                      </>
                    </div>
                  </div>
                </div>
                <a href="javascript:void(0)" className="bookmark">
                  <i className="iBookmark_F" />
                </a>
              </div>
              <div className="expldescmain">
                <div className="expldescall">
                  {this.state.detailObj && this.state.detailObj.news_url && (
                    <h1>
                      <a href={this.state.detailObj.news_url} target="_blank">
                        {this.state.detailObj !== undefined
                          ? this.state.detailObj.header
                          : ""}
                      </a>
                    </h1>
                  )}

                  {this.state.detailObj !== undefined && this.state.detailObj.news_url === undefined && (
                      <h1>
                        {this.state.detailObj !== undefined
                          ? this.state.detailObj.header
                          : ""}
                      </h1>
                  )}
                  <div className='blogPublistInfo'>
                      <div className="fuserfollow">
                          <figure className={this.props.type === "blog" ? "userlogo welogo" : "userlogo"}>
                              <img src={this.state.detailObj && this.state.detailObj.userProfileImage !== undefined && this.state.detailObj.userProfileImage !== "" && this.state.detailObj.userProfileImage !== null
                                    ? getCDNUrl(this.state.detailObj && this.state.detailObj.userProfileImage) : !this.state.item.userEntityType ? (this.state.item.userType === "INDIVIDUAL" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png") : "https://cdn.dscovr.com/images/circleDefault.png"
                                }
                                alt=""
                              />
                          </figure>
                          <div
                            onClick={(e) => {!this.state.item.userEntityType ? this.redirectToProfile(this.state.detailObj.userCustomUrl) : redirectToCircle(this.state.detailObj.userCustomUrl)}}
                            style={{
                              cursor: "pointer",
                              textTransform: "capitalize",
                            }}
                          >
                            {this.state.detailObj.name
                              ? this.state.detailObj.name
                              : ""}
                          </div>
                        </div>

                      {this.state.item && this.state.item.publishedTime && (
                        <div className='publishBlk'>
                          Published on{" "}
                          {this.getFormattedDate(this.state.item.publishedTime)}
                        </div>
                      )}

                      {this.state.item &&
                        !this.state.item.publishedTime &&
                        this.state.item.createTime && (
                          <div className='publishBlk'>
                            Posted on{" "}
                            {this.getFormattedDate(this.state.item.createTime)}
                          </div>
                        )}
                  </div>
                  <hr />
                  {this.state.detailObj !== undefined &&
                    this.state.detailObj.html_text !== undefined && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.detailObj.html_text,
                        }}
                      />
                    )}

                  {this.state.detailObj !== undefined &&
                    this.state.detailObj.html_text === undefined &&
                    this.state.detailObj.txt_data !== undefined && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.detailObj.txt_data
                            ? this.state.detailObj.txt_data.replace(
                              /&nbsp;/g,
                              " "
                            )
                            : "",
                        }}
                      />
                    )}

                  <div className="tagsblk">
                    {this.state.detailObj !== undefined &&
                      this.state.detailObj.summary_text !== undefined &&
                      Object.values(this.state.detailObj.summary_text).map(
                        (hashTag, val, idx) => {
                          return <a href={'/explore-hashtag/' + hashTag}>#{hashTag}</a>
                          // (
                          //   idx <= 2 && 
                          // );
                        }
                      )}
                  </div>
                </div>
              </div>

              <div className="unAuthSummrow">
                <div className="topDesc">
                  <h2 className="h2ttl">
                    Trending Opportunities{" "}
                    <Link
                      className="link"
                      onClick={() =>
                        this.setState({ loginRequired: true })
                      }
                    >
                      View All
                    </Link>
                  </h2>
                </div>
                <div className="explLatarticle">
                  <OwlCarousel
                    id={"unauthProjectcarousel"}
                    autoWidth={true}
                    nav={false}
                    margin={12}
                    items={3}
                    loop={false}
                    rewind={true}
                  >
                    {this.state.opportunities &&
                      this.state.opportunities.map((data, index) => {
                        if (index < 3) {
                          return data.secondaryEntityType === "JOB" ||
                            data.secondaryEntityType === "ASSIGNMENT" ? (
                            <div className="item">
                              <div className="projectlist">
                                <div className="projectlistinn">
                                  <div className="projectlisttop">
                                    <div className="projheadOuter">
                                      <div
                                        className="projhead"
                                        onClick={(e) =>
                                          this.modalOpen(data.project.slug)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <figure
                                          className="complogo"
                                          onClick={(e) =>
                                            this.modalOpen(data.project.slug)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <LazyLoadImage
                                            effect="blur"
                                            src={
                                              data &&
                                                data.project &&
                                                !_.isNull(
                                                  data.project.coverImage
                                                ) &&
                                                !_.isUndefined(
                                                  data.project.coverImage
                                                )
                                                ? data.project.coverImage
                                                : "https://cdn.dscovr.com/images/project-default.webp"
                                            }
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "https://cdn.dscovr.com/images/project-default.jpg";
                                            }}
                                            alt=""
                                          />
                                        </figure>
                                        <div>
                                          <h5>
                                            {data && unescape(data.creatorName)}
                                          </h5>
                                          {data &&
                                            data.project &&
                                            data.project.location &&
                                            data.project.location.city && (
                                              <span className="address">
                                                {data.project.location &&
                                                  data.project.location.country}
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                    {((data &&
                                      data.project &&
                                      (data.project.cost ||
                                        data.project.remuneration ||
                                        data.project.renumeration) > 0 &&
                                      data.project.isDisclosed === false) ||
                                      data.project.participationCount > 0) && (
                                        <div className="projectpricetime">
                                          {data &&
                                            this.getCost(data.project) > 0 &&
                                            data.project.isDisclosed ===
                                            false && (
                                              <span className="price">
                                                {" "}
                                                {data.project.currency}{" "}
                                                {nFormatter(
                                                  this.getCost(data.project),
                                                  2
                                                )}{" "}
                                                {!_.isNull(
                                                  data.project.packageType
                                                ) &&
                                                  !_.isUndefined(
                                                    data.project.packageType
                                                  ) &&
                                                  data.project.packageType.toLowerCase() !==
                                                  "custom" &&
                                                  data.project.packageType}
                                              </span>
                                            )}

                                          {data.project.participationCount > 0 ? (
                                            <>
                                              {data.project.participationCount ===
                                                0 ||
                                                data.project.participationCount ===
                                                1 ? (
                                                <span className="perticipent">
                                                  {unescape(
                                                    data.project
                                                      .participationCount
                                                  )}{" "}
                                                  Applicant
                                                </span>
                                              ) : (
                                                <span className="perticipent">
                                                  {unescape(
                                                    data.project
                                                      .participationCount
                                                  )}{" "}
                                                  Applicants
                                                </span>
                                              )}
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      )}
                                  </div>
                                  <div className="projectlistmid">
                                    <h4>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(e) =>
                                          this.modalOpen(data.project.slug)
                                        }
                                      >
                                        <span>
                                          {data &&
                                            data.project &&
                                            data.project.title &&
                                            data.project.title
                                              .split("\\n")
                                              .map((title) => (
                                                <>
                                                  {convertUnicode(title)}
                                                  <br />
                                                </>
                                              ))}
                                        </span>
                                        {/*{title}*/}
                                      </a>
                                    </h4>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(e) =>
                                        this.modalOpen(data.project.slug)
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <p style={{ cursor: "pointer" }}>
                                        {data &&
                                          data.project &&
                                          data.project.shortBrief &&
                                          data.project.shortBrief
                                            .split("\\n")
                                            .map((shortBrief) => (
                                              <>
                                                {convertUnicode(shortBrief)}
                                                <br />
                                              </>
                                            ))}
                                      </p>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="item">
                              <div className="projeventlist">
                                <div className="projeventlistinn">
                                  <figure
                                    className="eventimg"
                                    href="javascript:void(0)"
                                    onClick={(e) =>
                                      this.modalOpen(data.project.slug)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <img
                                      src={
                                        data &&
                                          data.project &&
                                          !_.isNull(data.project.coverImage) &&
                                          !_.isUndefined(data.project.coverImage)
                                          ? data.project.coverImage
                                          : "https://cdn.dscovr.com/images/project-default.webp"
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "https://cdn.dscovr.com/images/project-default.jpg";
                                      }}
                                      alt=""
                                    />
                                    {data &&
                                      this.getCost(data.project) > 0 &&
                                      data.project.isDisclosed === false && (
                                        <span className="price">
                                          {" "}
                                          {data.project.currency}{" "}
                                          {nFormatter(
                                            this.getCost(data.project),
                                            2
                                          )}{" "}
                                          {!_.isNull(
                                            data.project.packageType
                                          ) &&
                                            !_.isUndefined(
                                              data.project.packageType
                                            ) &&
                                            data.project.packageType.toLowerCase() !==
                                            "custom" &&
                                            data.project.packageType}
                                        </span>
                                      )}
                                  </figure>
                                  <div className="projeventdesc">
                                    <h4>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(e) =>
                                          this.modalOpen(data.project.slug)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {data &&
                                          data.project &&
                                          data.project.title &&
                                          data.project.title
                                            .split("\\n")
                                            .map((title) => (
                                              <>
                                                {convertUnicode(title)}
                                                <br />
                                              </>
                                            ))}
                                        {/*{title}*/}
                                      </a>
                                    </h4>
                                    <div
                                      className="d-flex"
                                      style={{ cursor: "default" }}
                                    >
                                      <div className="date">
                                        {dateUtil.format(
                                          new Date(
                                            data && data.project.beginningTime
                                          ),
                                          "DD"
                                        )}
                                        <span>
                                          {!_.isUndefined(
                                            data.project.beginningTime
                                          ) &&
                                            !_.isNull(
                                              data.project.beginningTime
                                            ) &&
                                            dateUtil
                                              .format(
                                                new Date(
                                                  data &&
                                                  data.project.beginningTime
                                                ),
                                                "MMM"
                                              )
                                              .toUpperCase()}
                                        </span>
                                        <span>
                                          {!_.isUndefined(
                                            data.project.beginningTime
                                          ) &&
                                            !_.isNull(
                                              data.project.beginningTime
                                            ) &&
                                            dateUtil
                                              .format(
                                                new Date(
                                                  data &&
                                                  data.project.beginningTime
                                                ),
                                                "YYYY"
                                              )
                                              .toUpperCase()}
                                        </span>
                                      </div>

                                      <div className="projeventdesctxt">
                                        <a
                                          href="javascript:void(0)"
                                          onClick={(e) =>
                                            this.modalOpen(data.project.slug)
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          <p>
                                            {data &&
                                              data.project &&
                                              data.project.shortBrief &&
                                              data.project.shortBrief
                                                .split("\\n")
                                                .map((shortBrief) => (
                                                  <>
                                                    {convertUnicode(shortBrief)}
                                                    <br />
                                                  </>
                                                ))}
                                          </p>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                  </OwlCarousel>
                </div>
              </div>

              <div className="unAuthSummrow">
                <div className="topDesc">
                  <h2 className="h2ttl">
                    Trending Community{" "}
                    <Link
                      className="link"
                      onClick={() =>
                        this.setState({ loginRequired: true })
                      }
                    >
                      View All
                    </Link>
                  </h2>
                </div>
                <div className="explLatarticle">
                  <OwlCarousel
                    id={"unauthCirclecarousel"}
                    autoWidth={true}
                    nav={false}
                    margin={24}
                    items={3}
                    loop={false}
                    rewind={true}
                  >
                    {this.state.unAuthCircle.map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          <div className="CirclefrYouEachbx">
                            <a href={"/community/" + item.slug}>
                              <div className="CirclefrYouImgbx">
                                <img
                                  src={
                                    item.resizedCoverImages &&
                                      item.resizedCoverImages.compressed
                                      ? item.resizedCoverImages.compressed
                                      : "https://cdn.dscovr.com/images/prof-banner.webp"
                                  }
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://cdn.dscovr.com/images/prof-banner.png";
                                  }}
                                  alt=""
                                />
                                <figure>
                                  <LazyLoadImage
                                    effect="blur"
                                    src={
                                      item.resizedProfileImages &&
                                        item.resizedProfileImages.compressed
                                        ? item.resizedProfileImages.compressed
                                        : "https://cdn.dscovr.com/images/circleDefault.webp"
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "https://cdn.dscovr.com/images/circleDefault.png";
                                    }}
                                    alt=""
                                  />
                                </figure>
                              </div>
                            </a>
                            <div className="CirclefrYouDescbx">
                              <div className="circleTitleBl">
                                <h5>
                                  <span>
                                    <a href={"/community/" + item.slug}>
                                      {item.title}
                                    </a>
                                  </span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </OwlCarousel>
                </div>
              </div>

              <div className="unAuthSummrow">
                <div className="topDesc">
                  <h2 className="h2ttl">
                    Trending Feeds{" "}
                    <Link
                      className="link"
                      onClick={() =>
                        this.setState({ loginRequired: true })
                      }
                    >
                      View All
                    </Link>
                  </h2>
                </div>
                <div className="explLatarticle">
                  <OwlCarousel
                    id={"unauthFeedcarousel"}
                    autoWidth={true}
                    nav={false}
                    dots={false}
                    margin={12}
                    items={3}
                    loop={false}
                    rewind={true}
                  >
                    {this.state.unAuthPost && this.state.unAuthPost.map((item) => {
                      return (
                        <div className="item" key={item.id}>
                          <FeedsUnauthItem item={item} key={item.id} signUpRequired={this.props.signUpRequired} loginRequired={this.loginRequired} />
                        </div>
                      );
                    })}
                  </OwlCarousel>
                </div>
              </div>

              <div className="bottLoginfo">
                Our Editors bring to you interesting, curated stories across
                varied fields of interest. <Link to="/signup">Join Us</Link>
              </div>

              <div className="bkbackdrop2">
                <div className="unauthLoginPop">
                  <div className="unauthLoginPopdesc">
                    <a
                      href="javascript:void(0)"
                      onClick={this.loginRequired.bind(this)}
                      className="bkloginBtn"
                    >
                      <i className="iArrow-Up" />
                      You must <span>login</span> to explore more
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {this.state.isModalOpen &&
               <ProjectDetailsCommonModal projectDetail={this.state.projectDetail} openModalClose={this.openModalClose} handleApply={this.handleApply} />
            }

          </div>
        )}
        {this.state.loginRequired && <AuthModalComponent handleLoginClose={this.handleLoginClose} />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    pageClickRequest: (data) => dispatch(pageClickRequest(data)),
  };
};

export default connect(null, mapDispatchToProps)(UnauthExploreDetailPage);
